import { Goal } from './goals';
import { getGoalAccounts } from './react/goals';
import { useCurrentUser } from './react/user';

export const phase1ShutdownAt = '2025-05-11T00:00:00Z'; // May 10 @ 5pm PDT

export const useGoalTransfersShutdownMessage = ({
    goal,
}: {
    goal: Goal | undefined;
}): string | undefined => {
    const { featureFlags } = useCurrentUser();
    if (!featureFlags?.isShutdownV1Enabled) return;
    const myGoalAccount = goal
        ? getGoalAccounts(goal).find((fe) => fe.isMine)
        : undefined;
    return myGoalAccount?.closingExternalAccountMask
        ? `Your Plenty account is closing. All funds will be automatically withdrawn to your account ending in ${myGoalAccount.closingExternalAccountMask}. Individual transactions within goals are no longer allowed.`
        : `Plenty is closing. We’ve cancelled any upcoming deposits. Please withdraw or transfer your funds.`;
};
